import { render, staticRenderFns } from "./applies.vue?vue&type=template&id=0f6cb1cc&"
import script from "./applies.vue?vue&type=script&lang=js&"
export * from "./applies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports